module.exports = __webpack_public_path__ + "static/media/Anoushka.85e80005.jpg";